import axios from 'axios'

import { API_BASE_URL } from 'utils/consts.mjs'

const API_CHANGE_EMAIL_PREFIX = 'user/change_email'

interface sendVerificationCodePhase1Params {
  password: string
  lang: string
}
export const sendVerificationCodePhase1 = (
  data: sendVerificationCodePhase1Params,
) => {
  return axios({
    withCredentials: true,
    method: 'post',
    baseURL: API_BASE_URL,
    url: `${API_CHANGE_EMAIL_PREFIX}/send_phase_1_code`,
    data,
  })
}

interface sendVerificationCodePhase2Params {
  newEmail: string
  lang: string
}
export const sendVerificationCodePhase2 = ({
  newEmail,
  lang,
}: sendVerificationCodePhase2Params) => {
  return axios({
    withCredentials: true,
    method: 'post',
    baseURL: API_BASE_URL,
    url: `${API_CHANGE_EMAIL_PREFIX}/send_phase_2_code`,
    data: {
      new_email: newEmail,
      lang,
    },
  })
}

interface ValidateVerificationCodeParams {
  verificationCode: string
}
export const ValidateVerificationCode = ({
  verificationCode,
}: ValidateVerificationCodeParams) => {
  return axios({
    withCredentials: true,
    method: 'post',
    baseURL: API_BASE_URL,
    url: `${API_CHANGE_EMAIL_PREFIX}/validate_code`,
    data: {
      verification_code: verificationCode,
    },
  })
}

interface ConfirmChangeEmailParams {
  code: string
  lang: string
}

export const confirmChangeEmail = ({
  code,
  lang,
}: ConfirmChangeEmailParams) => {
  return axios({
    withCredentials: true,
    method: 'post',
    baseURL: API_BASE_URL,
    url: `${API_CHANGE_EMAIL_PREFIX}/confirm`,
    data: {
      verification_code: code,
      lang,
    },
  })
}
